module.exports = __webpack_public_path__ + "static/media/77_galvanized_steel_metal_seamless.88e7ee64.jpg";